import { render, staticRenderFns } from "./BannerDetail.vue?vue&type=template&id=278ccd9b&"
import script from "./BannerDetail.vue?vue&type=script&lang=js&"
export * from "./BannerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports